module.exports = __webpack_public_path__ + "img/CMED.587634fb.png";